import { Directive, InjectionToken } from '@angular/core';

export const KT_PORTLET_TITLE = new InjectionToken<KtPortletTitle>('KtPortletTitle');

@Directive({
	selector: 'ktPortletTitle,[ktPortletTitle]',
	providers: [{ provide: KT_PORTLET_TITLE, useExisting: KtPortletTitle }],
})
export class KtPortletTitle {}
